import auth from '@/router/auth'

export default [
  {
    path: '/projects',
    name: 'list-project',
    component: () => import('@/components/project/Index'),
    beforeEnter: auth.requireAuth
  },
  {
    path: '/projects/edit/:id/:tab',
    name: 'edit-project',
    component: () => import('@/components/project/Edit'),
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/project/router.js